// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Chat__Jsx3 = require("../../../uikit/reason/molecules/Chat/Chat__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var TailwindMerge = require("tailwind-merge");
var React = require("linkifyjs/react");
var AgentProfilePhoto = require("../../common/Agent/AgentProfilePhoto.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var Conversation__MessageFiles = require("../Conversation__MessageFiles.bs.js");
var Conversation__MessageImages = require("../Conversation__MessageImages.bs.js");
var ConversationPageConversationMessagesMessage_message_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessage_message_graphql.bs.js");
var ConversationPageConversationMessagesMessage_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessage_conversation_graphql.bs.js");
var ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql = require("../../../__generated__/ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.bs.js");

var convertFragment = ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageConversationMessagesMessage$ChatParticipantMenu(props) {
  var agent = use(props.agent);
  var firstName = agent.firstName;
  if (firstName === undefined) {
    return null;
  }
  var phone = agent.phone;
  return JsxRuntime.jsxs(MenuV5.Menu.make, {
              button: props.button,
              children: [
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "/agents/" + agent.id,
                      children: "View profile"
                    }),
                phone !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "tel:" + phone,
                                children: "Call"
                              }),
                          JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "sms:" + phone,
                                children: "Send a text"
                              })
                        ]
                      }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                        onAction: (function (prim) {
                            
                          }),
                        isDisabled: true,
                        children: "No phone number for " + firstName
                      })
              ]
            });
}

var ChatParticipantMenu = {
  AgentFragment: AgentFragment,
  make: ConversationPageConversationMessagesMessage$ChatParticipantMenu
};

var convertFragment$1 = ConversationPageConversationMessagesMessage_message_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessage_message_graphql.node, convertFragment$1, fRef);
}

var MessageFragment_incomingMessageStatusState_decode = ConversationPageConversationMessagesMessage_message_graphql.Utils.incomingMessageStatusState_decode;

var MessageFragment_incomingMessageStatusState_fromString = ConversationPageConversationMessagesMessage_message_graphql.Utils.incomingMessageStatusState_fromString;

var MessageFragment_membershipStatusV5_decode = ConversationPageConversationMessagesMessage_message_graphql.Utils.membershipStatusV5_decode;

var MessageFragment_membershipStatusV5_fromString = ConversationPageConversationMessagesMessage_message_graphql.Utils.membershipStatusV5_fromString;

var MessageFragment = {
  incomingMessageStatusState_decode: MessageFragment_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: MessageFragment_incomingMessageStatusState_fromString,
  membershipStatusV5_decode: MessageFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: MessageFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$2 = ConversationPageConversationMessagesMessage_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessagesMessage_conversation_graphql.node, convertFragment$2, fRef);
}

var ConversationFragment_conversationVisibilityV5_decode = ConversationPageConversationMessagesMessage_conversation_graphql.Utils.conversationVisibilityV5_decode;

var ConversationFragment_conversationVisibilityV5_fromString = ConversationPageConversationMessagesMessage_conversation_graphql.Utils.conversationVisibilityV5_fromString;

var ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageConversationMessagesMessage(props) {
  var conversation = use$2(props.conversation);
  var message = use$1(props.message);
  var agent = UserSession.useAgentInfo();
  var match = message.from;
  var messageIsFromLoggedInUser = match !== undefined && match.__typename === "Agent" ? match.id === agent.id : false;
  var tmp;
  if (messageIsFromLoggedInUser) {
    tmp = null;
  } else {
    var match$1 = message.from;
    var tmp$1;
    if (messageIsFromLoggedInUser) {
      tmp$1 = null;
    } else {
      var exit = 0;
      if (match$1 !== undefined && match$1.__typename === "Agent") {
        var match$2 = match$1.membershipStatus;
        var exit$1 = 0;
        if (match$2 !== undefined && (match$2 === "ACTIVE" || match$2 === "TERMINATED") && match$2 !== "ACTIVE") {
          tmp$1 = JsxRuntime.jsx(Chat__Jsx3.ChatAvatar.make, {
                src: AvatarSrcUrl.place_holder,
                name: match$1.displayName,
                overlayIcon: "Unavailable",
                iconColor: Theme__Color__Vars.crimson
              });
        } else {
          exit$1 = 2;
        }
        if (exit$1 === 2) {
          var fragmentRefs = match$1.fragmentRefs;
          tmp$1 = JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatParticipantMenu, {
                agent: fragmentRefs,
                button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                      className: "!p-0 !border-none hover:cursor-pointer",
                      children: Caml_option.some(JsxRuntime.jsx(AgentProfilePhoto.make, {
                                profilePhoto: fragmentRefs,
                                className: "h-10 w-10"
                              }))
                    })
              });
        }
        
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$1 = JsxRuntime.jsx(Chat__Jsx3.ChatAvatar.make, {
              src: AvatarSrcUrl.place_holder,
              name: "A TAN User"
            });
      }
      
    }
    tmp = JsxRuntime.jsx("div", {
          children: tmp$1,
          className: "shrink-0"
        });
  }
  var tmp$2;
  if (messageIsFromLoggedInUser) {
    tmp$2 = null;
  } else {
    var match$3 = message.from;
    var tmp$3;
    tmp$3 = match$3 !== undefined && match$3.__typename === "Agent" ? JsxRuntime.jsx(ConversationPageConversationMessagesMessage$ChatParticipantMenu, {
            agent: match$3.fragmentRefs,
            button: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                  children: Caml_option.some(match$3.displayName)
                })
          }) : "A TAN User";
    tmp$2 = JsxRuntime.jsx("div", {
          children: tmp$3,
          className: "mb-1"
        });
  }
  var text = message.text;
  var tmp$4;
  if (text !== undefined && text !== "") {
    var match$4 = conversation.visibility;
    var tmp$5;
    tmp$5 = messageIsFromLoggedInUser ? (
        match$4 !== undefined ? (
            match$4 === "PRIVATE" || match$4 === "PUBLIC" ? (
                match$4 === "PRIVATE" ? "bg-sky-100" : "bg-green-100"
              ) : "bg-gray-100"
          ) : "bg-sky-100"
      ) : "bg-gray-100";
    tmp$4 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(React, {
                      children: text
                    }),
                className: "text-gray-900"
              }),
          className: TailwindMerge.twMerge([
                tmp$5,
                "shadow-sm py-2.5 px-3 rounded-md inline-block"
              ])
        });
  } else {
    tmp$4 = null;
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      tmp,
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    tmp$2,
                                    tmp$4,
                                    JsxRuntime.jsx(Conversation__MessageImages.make, {
                                          message: message.fragmentRefs
                                        }),
                                    JsxRuntime.jsx(Conversation__MessageFiles.make, {
                                          message: message.fragmentRefs
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(message.sentAt)), "p"),
                                          className: TailwindMerge.twMerge([
                                                messageIsFromLoggedInUser ? "text-right" : "text-left",
                                                "text-sm mt-2 text-gray-500"
                                              ])
                                        })
                                  ]
                                }),
                            className: "flex flex-col"
                          })
                    ],
                    className: TailwindMerge.twMerge([
                          messageIsFromLoggedInUser ? "col-start-5 justify-end" : "",
                          "flex flex-row space-x-2 col-span-8 leading-5"
                        ])
                  }),
              className: "grid grid-cols-12"
            });
}

var make = ConversationPageConversationMessagesMessage;

exports.ChatParticipantMenu = ChatParticipantMenu;
exports.MessageFragment = MessageFragment;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* MenuV5 Not a pure module */
